import React from 'react'

const ColonialStandardPattern = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-full z-5 bg-white">
      <div className="grid grid-rows-2 grid-cols-2 w-full h-full gap-1.5">
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
        <div className="bg-light"></div>
      </div>
    </div>
  )
}

export default ColonialStandardPattern
